import * as Sentry from "@sentry/react";
import { createBrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import App from "./App";
import ErrorPage from "./pages/error/error-page";
import React from "react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0.01,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter(
  [
    {
      path: import.meta.env.VITE_BASE_PATH,
      element: <App />,
      errorElement: <ErrorPage />,
    },
  ],
  {
    basename: document.querySelector("base")?.getAttribute("href") ?? "/",
  }
);
